export const SET_BBPS_HOME_PAGE_DATA = 'SET_BBPS_HOME_PAGE_DATA';
export const SET_BBPS_TESTIMONIAL_DATA = 'SET_BBPS_TESTIMONIAL_DATA';
export const SET_BBPS_BILLS_PAGE_DATA = 'SET_BBPS_BILLS_PAGE_DATA';
